<template>
  <van-row class="list-cell">
    <van-col class="member-info" span="24">
      <van-col style="">
        <img height="40" width="40" v-lazy="item.headimgurl" style="padding-top: 3px; margin-left: 5px;" v-if="item.headimgurl">
        <img height="40" width="40" :src="customer" style="padding-top: 3px; margin-left: 5px;" v-else>
      </van-col>
      <van-col style="margin-left: 10px; width: 80%;">
        <van-col span="24">
          <span v-if="item.username">{{ generateCustomizeString('phone') }} {{item.username}}</span>
          <span v-else>{{ generateCustomizeString('phone') }} {{generateCustomizeString('none')}}</span>
          <span style="padding-left: 6px;" v-if="item.remark">( {{item.remark}} )</span>
        </van-col>
        <van-col span="24">{{ generateCustomizeString('wechatName') }} {{item.wechatName}}
        </van-col>
      </van-col>
    </van-col>
    <!-- <van-col class="member-info" span="24" v-else>
      <van-col span="24">电话号码：{{item.username}}
      </van-col>
      <van-col span="24">微信昵称：{{item.wechatName}}
      </van-col>
    </van-col> -->
    <van-col span="12">
      {{generateCustomizeString('level')}}: {{item.memberLevel}}
    </van-col>
    <van-col span="12">
      {{generateCustomizeString('points')}}: {{item.memberPoint}}
    </van-col>
    <van-col span="12">
      {{generateCustomizeString('expense')}}: {{item.totleAmount}}
    </van-col>
    <van-col span="12">
      {{generateCustomizeString('credit')}}: {{item.memberCredit}}
    </van-col>
    <van-col span="24">
      {{generateCustomizeString('registrationDate')}}: {{ item.registrationDate | toLocalTime }}
    </van-col>
  </van-row>
</template>

<script>
import { generateCustomizeString } from '@/utils/i18n'
import { Row, Col, Tag } from 'vant'
import customer from '@/assets/customer.jpg'

export default {
  name: 'CustomerListCell',
  data() {
    return {
      imgLink: 'https://img.nzmai.com.cn/000robbme4_1537254820869.jpg',
      customer: customer
    }
  },
  props: {
    item: {
      type: Object,
      default: () => ({})
    }
  },
  components: {
    [Row.name]: Row,
    [Col.name]: Col,
    [Tag.name]: Tag
  },
  methods: {
    generateCustomizeString
  },
  created: function() {
    console.log(this.item)
  }
}
</script>

<style lang="less" scoped>
.member-info {
  margin-bottom: 5px;
  border-radius: 3px;
  padding: 0.3rem;
  text-align: left;
  // background: #f7f7f7;
  color: #3c3c3c;
}
.list-cell {
  padding: 10px 10px 5px 10px;
  line-height: 1.5rem;
  background: #fff;
  border-radius: 3px;
  margin-bottom: 0.3rem;
  border-bottom: 1px #e2e2e2 solid;
}
.fee {
  float: right;
  color: #ffa800;
  font-weight: bold;
}
</style>
